<template>
  <div class="regime-explainer">
    <div class="regime-explainer__title" v-if="$store.state.covid19.is_enabled">GSoD Indices 2021</div>
    <div class="regime-explainer__content flex flex-nowrap">
      <div class="flex-auto">
        <div class="mb-10"><strong>Regime types as of 31 December 2021</strong></div>
        <div class="mb-5">Democracy</div>

        <div class="flex flex-nowrap items-center pt-2">
          <div class="swatch bg--regime-dem-low flex-none"></div>
          <div class="flex-auto pl-10">
            Weak/Low performance
          </div>
        </div>

        <div class="flex flex-nowrap items-center pt-2">
          <div class="swatch bg--regime-dem-mid flex-none"></div>
          <div class="flex-auto pl-10">
            Mid-range performance
          </div>
        </div>

        <div class="flex flex-nowrap items-center pt-2">
          <div class="swatch bg--regime-dem-high flex-none"></div>
          <div class="flex-auto pl-10">
            High performance
          </div>
        </div>
      </div>

      <div class="flex-auto mt-45">
        <div class="flex flex-nowrap items-center pt-2">
          <div class="swatch bg--regime-purple flex-none"></div>
          <div class="flex-auto pl-10">
            Hybrid regime
          </div>
        </div>

        <div class="flex flex-nowrap items-center pt-2">
          <div class="swatch bg--regime-orange flex-none"></div>
          <div class="flex-auto pl-10">
            Authoritarian regime
          </div>
        </div>
      </div>
    </div>
    <div class="regime-explainer__notice">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :width="35" :height="35" viewBox="0 -3 47 47">
        <g id="Component_25_7" data-name="Component 25 – 7" transform="translate(9 6)">
          <g transform="matrix(1, 0, 0, 1, -9, -6)" v-if="shadow" filter="url(#Ellipse_6)">
            <circle id="Ellipse_6-2" data-name="Ellipse 6" cx="14.5" cy="14.5" r="14.5" transform="translate(9 6)" fill="#004c65"/>
          </g>
          <g transform="matrix(1, 0, 0, 1, -9, -6)" v-else>
            <circle id="Ellipse_6-2" data-name="Ellipse 6" cx="14.5" cy="14.5" r="14.5" transform="translate(9 6)" fill="#004c65"/>
          </g>
          <text id="_" data-name="!" transform="translate(3 1.6)" fill="#fff" font-size="21" font-family="Yrsa-Bold, Yrsa" font-weight="700"><tspan x="8.791" y="20">!</tspan></text>
        </g>
      </svg>
      <div>
        Current version includes data up to 31 December, 2021
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'regime-explainer'
}
</script>

<style lang="scss" scoped>
  @import '~@/components/sass/shared/colors';

  .mt-45 {
    margin-top: 53px;
  }

  .regime-explainer {
    font-size: 13px;
    width: 400px;

    &__title {
      font-size: 15px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    &__notice{
      background: #f1f3f7;
      display: flex;
      align-items: center;
      font-size: 14px;
      padding: 5px;
      margin-top: 35px;
    }
  }

  .swatch {
    display: block;
    height: 10px;
    width: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/misc/RegimeExplainer.vue